import { render, staticRenderFns } from "./Speaker.vue?vue&type=template&id=51cb7dc8&"
import script from "./Speaker.vue?vue&type=script&lang=js&"
export * from "./Speaker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports